import { createContext } from 'preact';
import {
  DEFAULT_WIDGET_CONSENT_STATE,
  type WidgetConsentState,
} from './consentState';

export interface WidgetConsentContextValue {
  consentState: WidgetConsentState;
  setConsentState: (consentState: WidgetConsentState) => void;
}

export const ConsentContext = createContext<WidgetConsentContextValue>({
  consentState: DEFAULT_WIDGET_CONSENT_STATE,
  setConsentState: () => undefined,
});
